module.exports = __webpack_public_path__ + "img/numberplatePlakette.972cf566.svg";